import { VersionsPage } from '@/app/VersionsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/theme-versions')({
    component: () => (
        <div className='flex h-full w-full'>
            <VersionsPage/>
        </div>
    )
})